module.exports = __webpack_public_path__ + "img/580.036a300b.jpg";